import { render, staticRenderFns } from "./IconRightBottom1.vue?vue&type=template&id=12f4ed29&"
import script from "./IconRightBottom1.vue?vue&type=script&lang=js&"
export * from "./IconRightBottom1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12f4ed29')) {
      api.createRecord('12f4ed29', component.options)
    } else {
      api.reload('12f4ed29', component.options)
    }
    module.hot.accept("./IconRightBottom1.vue?vue&type=template&id=12f4ed29&", function () {
      api.rerender('12f4ed29', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/PopupButtonPositions/IconRightBottom1.vue"
export default component.exports